document.addEventListener("DOMContentLoaded", () => {
    if (!document.querySelector(".faq")) return;

    document.querySelectorAll(".faq__question").forEach((question) => {
        question.addEventListener("click", (e) => {
            e.preventDefault();
            question.closest(".faq__item").classList.toggle("is-open");
        });
    });
});
